module.exports = __webpack_public_path__ + "static/img/5.5345dc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/5.png
// module id = KGUb
// module chunks = 0